import WorkContext from "@/components/commons/Work/WorkContext";
import GridState from "@/components/commons/Work/GridWork/GridState";
import Dictionary from "@/types/Dictionary";

/** 
 * Classe de base d'une déclinaison de Context par type de Grid
 * @description A utiliser si nécessité d'avoir des propriétés propres au Grid
 */
export default class GridContext extends WorkContext {
	/** Indique si la pagination doit utilisé ou non sur le GridWork */
	private usePagination: boolean = false;

	/** Constructeur avec paramètres */
	public constructor(state: GridState, results: any, configs: Dictionary<any>, variant: string, showConfigButtons: boolean = false) {
		super(state, results, configs, variant, showConfigButtons);
	}

	/** Renvoi si la pagination doit utiliser ou non sur le GridWork */
	public get UsePagination(): boolean {
		return this.usePagination;
	}

	/** Affectation de l'utilisation de la pagination dans le GridWork */
	public set UsePagination(value: boolean) {
		this.usePagination = value;
	}
}